moment = require("moment")

convertToViewModel = (roundInfo) ->
  viewModel =
    club: roundInfo.club
    course: roundInfo.course
    weather: roundInfo.weather
    memo: roundInfo.memo
    owner: roundInfo.players[0]
    play_date: moment(roundInfo.play_date).format("YYYY/MM/DD")
    player_1: roundInfo.players?[1]
    player_2: roundInfo.players?[2]
    player_3: roundInfo.players?[3]

  viewModel

class RoundDetailInfoCtrl
  constructor: (@$scope) ->
    @roundInfo = convertToViewModel(@$scope.$parent.roundInfo)

RoundDetailInfoCtrl.$inject = [
  '$scope'
]

module.exports = RoundDetailInfoCtrl


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-info/round-info-controller.coffee